<div class="payment-creation-container">
  <app-onboarding-header></app-onboarding-header>
  <div class="loading-wrapper" *ngIf="isLoading">
    <app-loading-manteca></app-loading-manteca>
    <p class="loading-text">Procesando</p>
  </div>

  <div class="success-wrapper" *ngIf="isSuccess && !isLoading">
    <img src="assets/images/success-onboarding.svg" alt="Success" />
    <p class="success-text">
      <img src="assets/icons/circular-tick.svg" alt="Success" /> ¡Pago exitoso!
    </p>
  </div>

  <div class="error-wrapper" *ngIf="error && !isLoading && !isSuccess">
    <img src="assets/icons/error-payment.svg" alt="Error" />
    <p class="error-text">{{ error }}</p>
  </div>

  <div class="close-button-wrapper" *ngIf="isSuccess || error">
    <button appButton="primary" class="max-width" (click)="redirectWithParams()">
      Cerrar ventana
    </button>
  </div>
</div>
<app-onboarding-footer [showButton]="false"></app-onboarding-footer>
